import React, { useState } from "react";
import { _Api } from "../../api/_call";
import { useNavigate, } from "react-router-dom";
import { success } from "../../common/helpers/toastify";
import { useTranslation } from 'react-i18next';
const DataPurgeModal = props => {
  const { dataPurge, } = props;
  let navigate = useNavigate();
  const [Masters, setMasters] = useState(false);
  const [ProductMasters, setProductMasters] = useState(false);
  const [Transaction, setTransaction] = useState(false);
  const [text,setText]=useState("")
  const { t } = useTranslation();
  const removedata = async () => {
    try {
      const postdata = {
        master: Masters ? 1 : 0,
        productMaster: ProductMasters ? 1 : 0,
        transaction: Transaction ? 1 : 0
      };
      let res = await _Api(postdata, `api/v1/App/rmcollection/data`);
      if (res.code === 200) {
        if (Transaction === 1 && ProductMasters === 1) {
          success(t("Clear Data SuccessFully"));
          navigate("/app/product/main");
        } else if (Transaction === 1) {
          success(t("Clear Data SuccessFully"));
          navigate("/app/inventory");
        } else {
          success(t("Clear Data SuccessFully"));
          navigate("/app/product/main");
        }
      }
    } catch (err) {
      console.log(err, "err");
    }
  };
  const handleChecked=(e,label)=>{
    if(label==="Masters"){
      setMasters(e.target.checked);
      setProductMasters(e.target.checked);
      setTransaction(e.target.checked);
      if(e.target.checked)
      setText("If you select Masters, Product Masters and Transaction will be selected automatically")
    else{
      setText("")
    }
    }
    if(label==="ProductMasters"){
      if(Masters&& e.target.checked === false)
      {
        setText("Masters is selected, so Product Masters cannot be deselected");
        return;
      }
      setProductMasters(e.target.checked);
      setTransaction(e.target.checked);
      if(e.target.checked)
      setText("If you select Product Masters, Transaction will be selected automatically" )
      else{
        setText("")
      }
  }
    if(label==="Transaction"){
      if((Masters || ProductMasters) && e.target.checked === false)
      {
        if(Masters)
        setText("Masters is selected, so Transaction cannot be deselected");
        else if(ProductMasters)
        setText("Product Masters is selected, so Transaction cannot be deselected");
        return;

      }
      setTransaction(e.target.checked);
      setText("")
    }

  }

  if (!dataPurge) {
    return null;
  }

  return (
    <div className="modal fade data-purge-modal" id="dataPurgeModal" tabIndex="-1" aria-labelledby="dataPurgeModalLabel" aria-hidden="true">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="dataPurgeModalLabel">{t("Data Purge")}</h5>
                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
              </div>
              <div className="modal-body">
                <div className="checkbox-row">
                  <div className="checkbox checkbox-custom checkbox-row-single">
                    <div className="com-check" id="">
                      <input
                        type="checkbox"
                        id="Masters"
                        checked={Masters ? 'checked' : ''}
                        // onChange={(e) => setMasters(e.target.checked)}
                        onChange={(e) => handleChecked(e,"Masters")}
                      />
                      <label htmlFor="Masters" className="com-check-label"></label>
                    </div>
                    <label
                      className="mb10 label-control tooltipfull p-l-10 checkbox_sm v-m"
                      htmlFor="Masters"
                    >
                      {t("Masters")}
                    </label>
                  </div>
                  <div className="checkbox checkbox-custom checkbox-row-single">
                    <div className="com-check" id="">
                      <input
                        type="checkbox"
                        id="ProductMasters"
                        checked={ProductMasters ? 'checked' : ''}
                        // onChange={(e) => setProductMasters(e.target.checked)}
                        onChange={(e) => handleChecked(e,"ProductMasters")}
                      />
                      <label htmlFor="ProductMasters" className="com-check-label"></label>
                    </div>
                    <label
                      className="mb10 label-control tooltipfull p-l-10 checkbox_sm v-m"
                      htmlFor="ProductMasters"
                    >
                      {t("Product Masters")}
                    </label>
                  </div>
                  <div className="checkbox checkbox-custom checkbox-row-single">
                    <div className="com-check" id="">
                      <input
                        type="checkbox"
                        id="Transaction"
                        checked={Transaction ? 'checked' : ''}
                        // onChange={(e) => setTransaction(e.target.checked)}
                        onChange={(e) => handleChecked(e,"Transaction")}
                      />
                      <label htmlFor="Transaction" className="com-check-label"></label>
                    </div>
                    <label
                      className="mb10 label-control tooltipfull p-l-10 checkbox_sm v-m"
                      htmlFor="Transaction"
                    >
                      {t("Transaction")}
                    </label>
                  </div>
                  <span style={{color:"red"}}>
                    {t(text)}
                  </span>
                </div>
              </div>
              <div className="modal-footer">
                <button type="button" data-bs-dismiss="modal" onClick={removedata} className="com-btn">{t("Submit")}</button>
              </div>
            </div>
          </div>
        </div>
  );
};

export default DataPurgeModal;